<div class="flex h-screen overflow-hidden bg-slate-50">
  <app-sidebar [menuItems]="filteredMenuItems()"></app-sidebar>

  <main class="flex-1 flex flex-col min-w-0">
    <div class="sticky top-0 z-[500] bg-white border-b border-slate-50 shadow-xs">
      <div class="px-8 py-3 flex items-center justify-between gap-4 border-b border-slate-50 bg-white">
        <app-breadcrumb [breadcrumbs]="breadcrumbs" [parentRoute]="parentRoute"></app-breadcrumb>
      </div>

      <!-- Active project banner: prominent so the user always knows what they're working on -->
      @if (project(); as p) {
        <div class="flex items-center gap-4 border-b border-slate-100 bg-gradient-to-r from-primary-50/70 to-white px-8 py-4">
          <div class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-primary text-white shadow-sm">
            <mat-icon>folder_open</mat-icon>
          </div>
          <div class="min-w-0 flex-1">
            <div class="flex flex-wrap items-center gap-x-3 gap-y-1">
              <h1 class="truncate text-l font-black text-slate-900" [title]="p.name">{{ p.name }}</h1>
              @if (p.code) {
                <span class="rounded-md bg-white px-2 py-0.5 font-mono text-[11px] font-bold uppercase tracking-wide text-slate-500 ring-1 ring-slate-200">{{ p.code }}</span>
              }
              <span class="inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wide" [class]="statusClass(p.status)">
                {{ statusLabel(p.status) }}
              </span>
            </div>
            <p class="mt-0.5 text-xs font-medium text-slate-500">
              {{ typeLabel(p.projectType) }}
              @if (p.institution?.name) { <span class="text-slate-300">·</span> {{ p.institution?.name }} }
            </p>
          </div>
        </div>
      }

      <!-- Lifecycle phase stepper -->
      <div class="px-8 py-3">
        <div class="flex items-stretch gap-2">
          @for (phase of phases; track phase.id; let i = $index) {
            <button
              type="button"
              (click)="selectPhase(phase.id)"
              class="group relative flex flex-1 items-center gap-3 rounded-xl border px-4 py-2.5 text-left transition-all duration-200"
              [ngClass]="
                selectedPhase() === phase.id
                  ? 'border-primary-500 bg-primary-50 shadow-sm'
                  : 'border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50'
              "
            >
              <!-- Step number / icon -->
              <div
                class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg text-sm font-semibold transition-colors"
                [ngClass]="
                  selectedPhase() === phase.id
                    ? 'bg-primary-500 text-white'
                    : 'bg-slate-100 text-slate-500 group-hover:bg-slate-200'
                "
              >
                <mat-icon class="!text-lg">{{ phase.icon }}</mat-icon>
              </div>

              <div class="min-w-0 flex-1">
                <div class="flex items-center gap-2">
                  <p
                    class="truncate text-sm font-semibold"
                    [ngClass]="selectedPhase() === phase.id ? 'text-primary-700' : 'text-slate-700'"
                  >
                    {{ phase.label }}
                  </p>
                  <!-- Live current-phase marker -->
                  @if (currentPhase() === phase.id) {
                    <span
                      class="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-700"
                    >
                      <span class="relative flex h-1.5 w-1.5">
                        <span
                          class="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"
                        ></span>
                        <span class="relative inline-flex h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
                      </span>
                      Current
                    </span>
                  }
                </div>
                <p class="truncate text-xs text-slate-400">{{ phase.caption }}</p>
              </div>

              <!-- Connector chevron -->
              @if (i < phases.length - 1) {
                <mat-icon class="!text-lg text-slate-300">chevron_right</mat-icon>
              }
            </button>
          }
        </div>
      </div>
    </div>

    <div class="flex-1 overflow-y-auto p-8 lg:p-10 bg-white">
      <div class="max-w-[90rem] mx-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
